import { useForm, ValidationError } from '@formspree/react';
import { StyleSheet, css } from 'aphrodite';

const ContactForm = () => {
  const [state, handleSubmit] = useForm('mdkokaep');

  if (state.succeeded) {
    return (
      <div className={css(styles.confirmationWrapper)}>
        <h3 className={css(styles.confirmationTitle)}>Message Sent!</h3>
        <p className={css(styles.confirmationText)}>
          Thank you for reaching out.<br />
          Our team will get back to you shortly.
        </p>
      </div>
    );
  }

  return (
    <div className={css(styles.wrapper)}>
      <form className={css(styles.formWrapper)} onSubmit={handleSubmit}>
        
        <div className={css(styles.detailsBox)}>

          <div className={css(styles.formGroup)}>
            <label className={css(styles.label)}>Name</label>
            <input
              name="name"
              type="text"
              placeholder="Your Name here..."
              required
              className={css(styles.input)}
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
          </div>

          <div className={css(styles.formGroup)}>
            <label className={css(styles.label)}>Email Address</label>
            <input
              name="email"
              type="email"
              placeholder="Your email here..."
              required
              className={css(styles.input)}
            />
            <ValidationError prefix="Email" field="email" errors={state.errors} />
          </div>

          <div className={css(styles.formGroup)}>
            <label className={css(styles.label)}>Phone</label>
            <input
              name="phone"
              type="tel"
              placeholder="Your phone number here..."
              required
              className={css(styles.input)}
            />
            <ValidationError prefix="Phone" field="phone" errors={state.errors} />
          </div>

          <div className={css(styles.formGroup)}>
            <label className={css(styles.label)}>Message</label>
            <textarea
              name="message"
              rows={4}
              placeholder="Your message here..."
              required
              className={css(styles.input)}
            />
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </div>

          <button
            type="submit"
            disabled={state.submitting}
            className={css(styles.submitBtn)}
          >
            {state.submitting ? 'Sending...' : 'Send Message'}
          </button>

        </div>
      </form>
    </div>
  );
};

const styles = StyleSheet.create({

  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  formWrapper: {
    width: '100%',
    maxWidth: '600px',
  },

  detailsBox: {
    padding: '2rem',
    backgroundColor: 'var(--color-paper)',
    borderRadius: '18px',
    border: '1px solid rgba(35,79,64,.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.2rem',
    boxShadow: 'var(--shadow-soft)',
  },

  formGroup: {
    display: 'flex',
    flexDirection: 'column',
  },

  label: {
    marginBottom: '0.5rem',
    fontSize: '0.95rem',
    fontWeight: '600',
    color: 'var(--color-green)',
    fontFamily: 'var(--font-alt)',
  },

  input: {
    padding: '0.6rem 0.8rem',
    borderRadius: '8px',
    border: '1px solid rgba(35,79,64,.2)',
    backgroundColor: 'var(--color-white)',
    color: 'var(--color-ink)',
    fontFamily: 'var(--font-alt)',
    fontSize: '1rem',
    transition: '0.2s ease',

    ':focus': {
      outline: 'none',
      borderColor: 'var(--color-green)',
      boxShadow: '0 0 0 4px rgba(35,79,64,.08)',
    },
  },

  submitBtn: {
    marginTop: '1rem',
    padding: '0.8rem 2rem',
    backgroundColor: 'var(--color-green)',
    color: 'var(--color-white)',
    fontWeight: '700',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '999px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',

    ':hover': {
      transform: 'translateY(-2px)',
    },
  },

  confirmationWrapper: {
    padding: '3rem',
    backgroundColor: 'var(--color-green)',
    borderRadius: '12px',
    textAlign: 'center',
  },

  confirmationTitle: {
    fontSize: '2rem',
    fontWeight: '700',
    color: '#c8b289',
    marginBottom: '1rem',
  },

  confirmationText: {
    fontSize: '1.1rem',
    color: '#ccc',
    lineHeight: 1.5,
  },
});

export default ContactForm;
